import CryptoJS from "crypto-js";

const AES_KEY = "P3TBC#%H(NVSDFGHRTEDKVQ#*(%^&*GD";
const AES_IV = "1FBXPG1!YBMCXSAF";

export const decryptResponse = (encryptedText) => {
try {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(AES_KEY), {
      iv: CryptoJS.enc.Utf8.parse(AES_IV),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    console.log("Decrypted text:", decryptedText);

    // If the decrypted result is JSON, parse it
    try {
      return JSON.parse(decryptedText);
    } catch {
      // If it’s not JSON, return as plain text
      return decryptedText;
    }
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};
